import * as React from 'react';
import { Select, MenuItem, FormControl } from '@mui/material';

export interface CountryPhonePrefix {
    code: string;
    name: string;
    prefix: string;
    flag: string;
}

export const COUNTRY_PHONE_PREFIXES: CountryPhonePrefix[] = [
    // Europe
    { code: 'PT', name: 'Portugal', prefix: '+351', flag: '🇵🇹' },
    { code: 'ES', name: 'Spain', prefix: '+34', flag: '🇪🇸' },
    { code: 'FR', name: 'France', prefix: '+33', flag: '🇫🇷' },
    { code: 'DE', name: 'Germany', prefix: '+49', flag: '🇩🇪' },
    { code: 'IT', name: 'Italy', prefix: '+39', flag: '🇮🇹' },
    { code: 'GB', name: 'United Kingdom', prefix: '+44', flag: '🇬🇧' },
    { code: 'CH', name: 'Switzerland', prefix: '+41', flag: '🇨🇭' },
    { code: 'NL', name: 'Netherlands', prefix: '+31', flag: '🇳🇱' },
    { code: 'BE', name: 'Belgium', prefix: '+32', flag: '🇧🇪' },
    { code: 'AT', name: 'Austria', prefix: '+43', flag: '🇦🇹' },
    { code: 'SE', name: 'Sweden', prefix: '+46', flag: '🇸🇪' },
    { code: 'NO', name: 'Norway', prefix: '+47', flag: '🇳🇴' },
    { code: 'DK', name: 'Denmark', prefix: '+45', flag: '🇩🇰' },
    { code: 'FI', name: 'Finland', prefix: '+358', flag: '🇫🇮' },
    { code: 'PL', name: 'Poland', prefix: '+48', flag: '🇵🇱' },
    { code: 'CZ', name: 'Czech Republic', prefix: '+420', flag: '🇨🇿' },
    { code: 'GR', name: 'Greece', prefix: '+30', flag: '🇬🇷' },
    { code: 'IE', name: 'Ireland', prefix: '+353', flag: '🇮🇪' },
    { code: 'RO', name: 'Romania', prefix: '+40', flag: '🇷🇴' },
    { code: 'LU', name: 'Luxembourg', prefix: '+352', flag: '🇱🇺' },
    { code: 'HU', name: 'Hungary', prefix: '+36', flag: '🇭🇺' },
    { code: 'BG', name: 'Bulgaria', prefix: '+359', flag: '🇧🇬' },
    { code: 'HR', name: 'Croatia', prefix: '+385', flag: '🇭🇷' },
    { code: 'SK', name: 'Slovakia', prefix: '+421', flag: '🇸🇰' },
    { code: 'SI', name: 'Slovenia', prefix: '+386', flag: '🇸🇮' },
    { code: 'RS', name: 'Serbia', prefix: '+381', flag: '🇷🇸' },
    { code: 'UA', name: 'Ukraine', prefix: '+380', flag: '🇺🇦' },

    // Americas
    { code: 'US', name: 'United States', prefix: '+1', flag: '🇺🇸' },
    { code: 'CA', name: 'Canada', prefix: '+1', flag: '🇨🇦' },
    { code: 'BR', name: 'Brazil', prefix: '+55', flag: '🇧🇷' },
    { code: 'AR', name: 'Argentina', prefix: '+54', flag: '🇦🇷' },
    { code: 'MX', name: 'Mexico', prefix: '+52', flag: '🇲🇽' },
    { code: 'CO', name: 'Colombia', prefix: '+57', flag: '🇨🇴' },
    { code: 'CL', name: 'Chile', prefix: '+56', flag: '🇨🇱' },
    { code: 'PE', name: 'Peru', prefix: '+51', flag: '🇵🇪' },
    { code: 'VE', name: 'Venezuela', prefix: '+58', flag: '🇻🇪' },
    { code: 'EC', name: 'Ecuador', prefix: '+593', flag: '🇪🇨' },
    { code: 'UY', name: 'Uruguay', prefix: '+598', flag: '🇺🇾' },

    // Asia
    { code: 'CN', name: 'China', prefix: '+86', flag: '🇨🇳' },
    { code: 'IN', name: 'India', prefix: '+91', flag: '🇮🇳' },
    { code: 'JP', name: 'Japan', prefix: '+81', flag: '🇯🇵' },
    { code: 'KR', name: 'South Korea', prefix: '+82', flag: '🇰🇷' },
    { code: 'ID', name: 'Indonesia', prefix: '+62', flag: '🇮🇩' },
    { code: 'PH', name: 'Philippines', prefix: '+63', flag: '🇵🇭' },
    { code: 'VN', name: 'Vietnam', prefix: '+84', flag: '🇻🇳' },
    { code: 'TH', name: 'Thailand', prefix: '+66', flag: '🇹🇭' },
    { code: 'MY', name: 'Malaysia', prefix: '+60', flag: '🇲🇾' },
    { code: 'SG', name: 'Singapore', prefix: '+65', flag: '🇸🇬' },
    { code: 'PK', name: 'Pakistan', prefix: '+92', flag: '🇵🇰' },
    { code: 'BD', name: 'Bangladesh', prefix: '+880', flag: '🇧🇩' },
    { code: 'IL', name: 'Israel', prefix: '+972', flag: '🇮🇱' },
    { code: 'AE', name: 'UAE', prefix: '+971', flag: '🇦🇪' },
    { code: 'SA', name: 'Saudi Arabia', prefix: '+966', flag: '🇸🇦' },
    { code: 'TR', name: 'Turkey', prefix: '+90', flag: '🇹🇷' },

    // Africa
    { code: 'ZA', name: 'South Africa', prefix: '+27', flag: '🇿🇦' },
    { code: 'NG', name: 'Nigeria', prefix: '+234', flag: '🇳🇬' },
    { code: 'EG', name: 'Egypt', prefix: '+20', flag: '🇪🇬' },
    { code: 'KE', name: 'Kenya', prefix: '+254', flag: '🇰🇪' },
    { code: 'MA', name: 'Morocco', prefix: '+212', flag: '🇲🇦' },
    { code: 'AO', name: 'Angola', prefix: '+244', flag: '🇦🇴' },
    { code: 'MZ', name: 'Mozambique', prefix: '+258', flag: '🇲🇿' },
    { code: 'CV', name: 'Cape Verde', prefix: '+238', flag: '🇨🇻' },

    // Oceania
    { code: 'AU', name: 'Australia', prefix: '+61', flag: '🇦🇺' },
    { code: 'NZ', name: 'New Zealand', prefix: '+64', flag: '🇳🇿' },
];

export interface CountryPhonePrefixFieldProps {
    value?: string;
    id?: string;
    label?: string;
    disabled?: boolean;
    variant?: 'standard' | 'outlined' | 'filled' | 'nobox';
    onChange: (value: string) => void;
}

export const CountryPhonePrefixField = (props: CountryPhonePrefixFieldProps) => {
    const {
        value = '+351',
        id,
        label,
        disabled,
        variant = 'outlined',
        onChange,
    } = props;

    const width = variant === 'nobox' ? '85px' : (label ? '135px' : '115px');

    return (
        <FormControl
            size="small"
            style={{ width, flexShrink: 0, flexGrow: 0 }}
            variant={variant === 'nobox' ? 'standard' : variant}
        >
            <Select
                id={id ? `${id}-input` : undefined}
                disabled={disabled}
                value={value}
                label={label}
                onChange={e => onChange(e.target.value)}
                sx={variant === 'nobox' ? {
                    "& .MuiInput-underline:before": { borderBottom: "none" },
                    "& .MuiInput-underline:after": { borderBottom: "none" },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": { borderBottom: "none" },
                } : undefined}
            >
                {
                    COUNTRY_PHONE_PREFIXES.map(country => (
                        <MenuItem
                            id={id ? `${id}-option-${country.code}` : undefined}
                            key={country.code}
                            value={country.prefix}
                        >
                            {country.flag} {country.prefix}
                        </MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );
}
